<template>
  <v-dialog v-model="open" lazy width="500">
    <!-- The activator is the pagination info -->
    <template #activator="{ on }">
      <v-btn v-on="on" class="blue-grey--text" flat>{{ value }} / {{ total }}</v-btn>
    </template>
    <v-text-field
      v-model="page"
      @keyup.enter="closeAndEmitInput"
      append-icon="send"
      autofocus
      hide-details
      :rules="[val => Number(val) <= total && Number(val) > 0]"
      solo
    />
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    open: false,
    page: 1
  }),
  watch: {
    open() {
      if (!this.open) this.emitInput();
    },
    value() {
      this.page = this.value;
    }
  },
  created() {
    this.page = this.value;
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  methods: {
    closeAndEmitInput() {
      this.open = false;
      this.emitInput();
    },
    emitInput() {
      if (this.page !== this.value) {
        if (this.isValid(this.page)) {
          this.$emit("input", Number(this.page));
        } else {
          this.page = this.value;
        }
      }
    },
    isValid(val) {
      const isGraterThanZero = Number(val) > 0;
      const isLessThanTotal = Number(val) <= this.total;

      if (!isGraterThanZero) {
        this.$notify.error("Debes ingresar un número mayor a cero");
      }

      if (!isLessThanTotal) {
        this.$notify.error(
          `Debes ingresar un número menor o igual a ${this.total}`
        );
      }

      return isGraterThanZero && isLessThanTotal;
    }
  }
};
</script>